export default __webpack_public_path__ + "static/btn_img_2-8cdfb824019f0995b3ccf41627201372.jpg";